firebird.factory('videoLayoutAlgorithmService', [
    'logService',
    'videoGlobalService',
    function (logService, videoGlobalService) {
        var _layoutResizeData = null;
        var _isWideSpotlight = false;

        var service = {
            initialize: initialize,
            findBestLayout: findBestLayout,
            clearCurrentResizeData: clearCurrentResizeData,
            setCurrentResizeData: setCurrentResizeData,
            hasWideSpotlight: hasWideSpotlight
        };

        return service;

        function initialize(selfParam) {
            //TODO: this is being left in here during refactor to suppor the init flow used by video room controller
            //      as initialization patterns may need to change during initialization
        }

        function clearCurrentResizeData() {
            _layoutResizeData = null;
        }

        function setCurrentResizeData(data) {
            _layoutResizeData = data;
        }

        function hasWideSpotlight() {
            return _isWideSpotlight;
        }

        // given the list of video orientation (landscape or portrait) and optional maxvideo flag,
        // return a list of the best layout positions, each item with x, y, w, h.
        // input is a list of 'l', 'p', 'L' or 'P';

        function findBestLayout(layoutMethod, input, W, H, ratio1, ratio2) {
            var N = input.length;
            if (N == 0) {
                return [];
            }
            var w = 0,
                h = 0,
                w0 = 0,
                h0 = 0; // the width and height of the individual video elements.
            var x = 0,
                y = 0,
                x0 = 0,
                y0 = 0; // position of the individual video elements.
            var c = 0,
                r = 0,
                l = 0,
                p = null; // columns, rows and cells in last row.
            var is_wide; // whether smaller videos are on right (true) or top (false)

            //console.log('findBestLayout input=' + input.join(''));
            var has_maxvideo =
                input.filter(function (item) {
                    return item == 'L' || item == 'P';
                }).length > 0;

            if (layoutMethod == 'flexible' || layoutMethod == 'fixed' || layoutMethod === null) {
                var index_maxvideo = -1;
                var H_o, W_o, N_o, input_o;

                // exclude maxvideo from group layout in remaining space.
                if (has_maxvideo) {
                    input.forEach(function (item, index) {
                        if (item == 'L' || item == 'P') {
                            index_maxvideo = index;
                        }
                    });
                    H_o = H;
                    W_o = W;
                    N_o = N;
                    input_o = input;
                    input = input.slice(0).filter(function (item, index) {
                        return index != index_maxvideo;
                    });
                    N = input.length;
                    if (N == 0) {
                        return [{ x: 0, y: 0, w: W, h: H }];
                    }

                    // max video attempts to leave 240px on right or 135px on top for remaining videos.
                    // but with constraint that it is at most 90% of available width/height and at least 70% width/height.

                    if (_layoutResizeData) {
                        is_wide = _layoutResizeData.is_wide;
                        var fraction = _layoutResizeData.fraction;
                        if (!is_wide) {
                            w0 = W;
                            h0 = H * (1 - fraction);
                            H = H - h0;
                        } else {
                            h0 = H;
                            w0 = W * (1 - fraction);
                            W = W - w0;
                        }
                    } else if (input_o[index_maxvideo] == 'P') {
                        // maxvideo is portrait
                        if (H > W * ratio1) {
                            is_wide = false;
                            w0 = W;
                            h0 = Math.min(W * ratio1, Math.min(Math.max(H * 0.7, H - 135), H * 0.9));
                            H = H - h0;
                        } else {
                            is_wide = true;
                            h0 = H;
                            w0 = Math.min(H / ratio1, Math.min(Math.max(W * 0.7, W - 240), W * 0.9));
                            if (w0 < W / 2) {
                                // if spotlight width is too small, change ratio
                                w0 = Math.min(W / 2, H * ratio2);
                            }
                            W = W - w0;
                        }
                    } else {
                        // maxvideo is landscape
                        if (W >= H * ratio1) {
                            is_wide = true;
                            w0 = Math.min(H * ratio1, Math.min(Math.max(W * 0.7, W - 240), W * 0.9));
                            h0 = H;
                            W = W - w0;
                        } else {
                            is_wide = false;
                            h0 = Math.min(W / ratio1, Math.min(Math.max(H * 0.7, H - 135), H * 0.9));
                            w0 = W;
                            if (h0 < H / 2) {
                                // if spotlight height is too small, change ratio
                                h0 = Math.min(H / 2, W / ratio2);
                            }
                            H = H - h0;
                        }
                    }

                    _isWideSpotlight = is_wide;
                }

                // if has any portrait video, then allow different size videos in the layout.
                // each row has videos of same height, but width can change, to maintain the aspect ratio.
                // for landscape orientation, use ratio1, and for portrait, use 1/ratio1.

                var A_best = 0,
                    L_best = [];

                // width ratios of input
                var w_i = input.map(function (item) {
                    return item == 'p' || item == 'P' ? 1 / ratio1 : ratio1;
                });
                // total width ratios assuming height 1
                var w_t = w_i.reduce(function (sum, value) {
                    return sum + value;
                }, 0);

                // all layouts possible for N videos
                var layoutsN = function (N) {
                    if (N == 1) {
                        return [[[0]]]; // array of layouts; one layout = two dimensional array
                    }
                    var result = [];
                    var layouts = layoutsN(N - 1);
                    layouts.forEach(function (layout) {
                        var last = layout[layout.length - 1].slice(0);
                        var layout1 = layout.slice(0);
                        last.push(N - 1);
                        layout1.splice(layout1.length - 1, 1, last);
                        var layout2 = layout.slice(0);
                        layout2.push([N - 1]);
                        result.push(layout1);
                        result.push(layout2);
                    });
                    return result;
                };

                var layouts = layoutsN(N);

                //console.log('layouts(' + N + ')=' + JSON.stringify(layouts, null, '  '));

                // area using fixed video ratio for each layout
                var areas = layouts.map(function (layout) {
                    var rows = layout.length;
                    var w_r = layout.map(function (row) {
                        // sum of width ratios per row
                        return row
                            .map(function (index) {
                                return w_i[index];
                            })
                            .reduce(function (sum, value) {
                                return sum + value;
                            }, 0);
                    });
                    var w_max = Math.max.apply(null, w_r); // max width in rows
                    var fit_width = false;
                    if (w_max / rows >= W / H) {
                        // fit at max width, pad on top/bottom
                        // w_max:W = r:w
                        fit_width = true;
                        w = (W * ratio1) / w_max; // width of one landscape video
                        h = w / ratio1; // height of one video
                    } else {
                        // fit height, pad on left/right
                        // 1:h = rows:H
                        h = H / rows; // height of one video
                        w = h * ratio1; // width of one landscape video
                    }
                    var area = w_i
                        .map(function (value) {
                            // sum area of videos with fixed ratios
                            return h * (value == 'p' || value == 'P' ? w / (r * r) : w);
                        })
                        .reduce(function (sum, value) {
                            return sum + value;
                        }, 0);

                    // make flexible aspect ratio now.

                    var f_h = 1;
                    if (fit_width) {
                        if (layoutMethod != 'fixed') {
                            var f = Math.max.apply(
                                null,
                                layout.map(function (row) {
                                    var p = row.reduce(function (count, index) {
                                        return count + (input[index] == 'p' || input[index] == 'P' ? 1 : 0);
                                    }, 0);
                                    var l = row.length - p;
                                    if (l <= 0) {
                                        return 1;
                                    }
                                    var r_1 = p / (l * ratio1);
                                    return (ratio1 + r_1) / (1 + r_1);
                                })
                            );
                            f_h = Math.min(f, ratio1 / ratio2, H / (rows * h));
                        }
                    } else {
                        w_max = (W * rows) / H;
                    }

                    var h_1 = h * f_h;

                    w_r = layout.map(function (row) {
                        var p = row.reduce(function (count, index) {
                            return count + (input[index] == 'p' || input[index] == 'P' ? 1 : 0);
                        }, 0);
                        var l = row.length - p;

                        var w_p = f_h / ratio1;
                        var w_l = f_h * ratio1;
                        if (layoutMethod != 'fixed') {
                            if (l != 0 && w_l * l + w_p * p > w_max) {
                                w_l = (w_max - w_p * p) / l;
                            }
                            if (p != 0 && w_l * l + w_p * p < w_max) {
                                w_p = Math.min(f_h / ratio2, (w_max - w_l * l) / p);
                            }
                        }
                        var w_l_1 = (w_l * w) / ratio1,
                            w_p_1 = (w_p * w) / ratio1;

                        var f_d = row
                            .map(function (index) {
                                if (input[index] == 'p' || input[index] == 'P') {
                                    return (ratio1 * w_p_1) / h_1;
                                } else {
                                    return (ratio1 * w_l_1) / h_1;
                                }
                            })
                            .reduce(function (sum, value) {
                                return sum + value;
                            }, 0);
                        var area_1 = h_1 * (p * w_p_1 + l * w_l_1);
                        return [w_l_1, w_p_1, f_d, area_1, l, p];
                    });

                    // var l_t = w_r.reduce(function(sum, value) {
                    //     return sum + value[4];
                    // }, 0);
                    // var p_t = w_r.reduce(function(sum, value) {
                    //     return sum + value[5];
                    // }, 0);
                    var f_d = w_r.reduce(function (sum, value) {
                        return sum + value[2];
                    }, 0);
                    var area_n = w_r.reduce(function (sum, value) {
                        return sum + value[3];
                    }, 0);
                    w_r = w_r.map(function (value) {
                        return [value[0], value[1]];
                    });

                    //console.log('l+p=' + l_t + '+' + p_t + '=' + (l_t+p_t));
                    //console.log('f_d=' + f_d);
                    return [w, h, area, area_n, f_d, h_1, w_r];
                });

                // console.log('areas=' + JSON.stringify(layouts.map(function(layout, index) {
                //     var layout = layout.map(function(row) {
                //         return row.map(function(index) {
                //             return input[index];
                //         }).join('');
                //     }).join(',');
                //     var result = {};
                //     var area = areas[index];
                //     result[layout] = [Math.round(area[0]) + 'x' + Math.round(area[1]),
                //         Math.round(area[2]), Math.round(area[3]), Math.round(area[4]*100)/100, Math.round(area[5]),
                //         area[6].map(function(value) { return [Math.round(value[0]), Math.round(value[1])]})];
                //     return result;
                // }, null, '  ')));

                //console.log('layouts=' + layouts.length + ' areas=' + areas.length);
                var filled = areas
                    .map(function (value, index) {
                        return [value, index];
                    })
                    .filter(function (value) {
                        return Math.round(value[0][3]) >= Math.round(W * H - 1); // -1 for some error margin
                    });
                var index_best;
                //console.log('layouts=' + layouts.length + ' filled=' + filled.length + ' W*H=' + (W*H));
                if (!filled.length) {
                    // none of the layouts fill the area, return max area layout.
                    var area_best = Math.round(
                        Math.max.apply(
                            null,
                            areas.map(function (item) {
                                return item[3];
                            })
                        )
                    );
                    index_best = areas
                        .map(function (item, index) {
                            return [index, item[3]];
                        })
                        .filter(function (item) {
                            return Math.round(item[1]) == area_best;
                        });
                    if (index_best.length > 1) {
                        if (has_maxvideo && is_wide) {
                            // for wide/spotlight mode, pick the layout that fill the upper parts, if multiple.
                            index_best = index_best[0];
                        } else if (has_maxvideo && !is_wide) {
                            // for narrow/spotlight mode, pick the layout that fill the lower parts, if multiple found.
                            index_best = index_best[index_best.length - 1];
                        } else {
                            // for non-spotlight, pick a balanced layout, if multiple.
                            // The balanced layout will have smallest filled width.
                            var smallest = [-1, -1];
                            index_best.forEach(function (item) {
                                var layout = areas[item[0]];
                                var row_width = Math.max.apply(
                                    null,
                                    layouts[item[0]].map(function (row, r_i) {
                                        var w_s = row.map(function (index) {
                                            return input[index] == 'p' || input[index] == 'P'
                                                ? layout[6][r_i][1]
                                                : layout[6][r_i][0];
                                        });
                                        return w_s.reduce(function (sum, value) {
                                            return sum + value;
                                        }, 0);
                                    })
                                );
                                if (smallest[0] < 0 || smallest[1] > row_width) {
                                    smallest = [item[0], row_width];
                                }
                            });
                            index_best = smallest;
                        }
                    } else {
                        index_best = index_best[0];
                    }
                } else {
                    // otherwise pick from filled with minimum f_d
                    index_best = filled.reduce(
                        function (min, value) {
                            if (min[1] > value[0][4]) {
                                return [value[1], value[0][4]];
                            } else {
                                return min;
                            }
                        },
                        [-1, 100]
                    );
                }
                index_best = index_best[0];
                A_best = areas[index_best];
                //console.log('index_best=' + index_best + ' A_best=' + A_best);
                L_best = [];
                h = A_best[5];
                var layout = layouts[index_best];
                var y_i = H / 2 - (h * layout.length) / 2,
                    x_i = 0;

                if (has_maxvideo) {
                    if (!is_wide) {
                        y_i = 0;
                        y0 = h * layout.length;
                    } else {
                        y_i = H / 2 - (h * layout.length) / 2;
                    }

                    layout.forEach(function (row, r_i) {
                        y = y_i;
                        var w_s = row.map(function (index) {
                            return input[index] == 'p' || input[index] == 'P' ? A_best[6][r_i][1] : A_best[6][r_i][0];
                        });
                        if (!is_wide) {
                            var w_sum = w_s.reduce(function (sum, value) {
                                return sum + value;
                            }, 0);
                            x_i = W / 2 - w_sum / 2;
                        } else {
                            x_i = w0;
                        }

                        row.forEach(function (index, c_i) {
                            x = x_i;
                            w = w_s[c_i];
                            x_i += w;
                            L_best.push({ x: x, y: y, w: w, h: h });
                        });
                        y_i += h;
                    });

                    if (!is_wide && !_layoutResizeData) {
                        // maxvideo is bottom
                        if (y_i + h0 < H_o) {
                            if (input_o[index_maxvideo] == 'P') {
                                // maxvideo is portrait
                                h0 = Math.min(H_o - y_i, w0 * ratio1);
                            } else {
                                // maxvideo is landscape
                                h0 = Math.min(H_o - y_i, w0 / ratio2);
                            }
                        }
                    }

                    L_best.splice(index_maxvideo, 0, { x: x0, y: y0, w: w0, h: h0 });
                } else {
                    layout.forEach(function (row, r_i) {
                        y = y_i;
                        var w_s = row.map(function (index) {
                            return input[index] == 'p' || input[index] == 'P' ? A_best[6][r_i][1] : A_best[6][r_i][0];
                        });
                        var w_sum = w_s.reduce(function (sum, value) {
                            return sum + value;
                        }, 0);
                        x_i = W / 2 - w_sum / 2;

                        row.forEach(function (index, c_i) {
                            x = x_i;
                            w = w_s[c_i];
                            x_i += w;
                            L_best.push({ x: x, y: y, w: w, h: h });
                        });
                        y_i += h;
                    });
                }

                // // old algorithm that works in polynomial time, but with fixed aspect ratio.
                // for (r=1; r<=N; ++r) {
                //     //console.log('r=' + r);
                //     var w_r = w_t / r;
                //     var cols = [];
                //     w_c = 0;
                //     w_i.forEach(function(value, index) {
                //         w_c += value;
                //         var diff = w_c - w_r;
                //         if (diff > 0) {
                //             cols.push({index: index+1, w_t: w_c});
                //             w_c = (index == w_i.length - 1 ? 0 : diff);
                //         }
                //     });
                //     if (w_c > 0) {
                //         cols.push({index: w_i.length, w_t: w_c});
                //     }
                //     var w_t_max = 0;
                //     cols.forEach(function(item) {
                //         if (item.w_t > w_t_max) {
                //             w_t_max = item.w_t;
                //         }
                //     });

                //     h = W / w_t_max;
                //     if (h * r > H) {
                //         h = H / r;
                //     }
                //     var w_j = w_i.map(function(value) {
                //         return value * h;
                //     });
                //     var A = w_j.reduce(function(sum, value) {
                //         return sum + value * h;
                //     }, 0);

                //     //console.log('cols=' + JSON.stringify(cols));
                //     L = [];
                //     y = H/2 - (h*r)/2;
                //     for (var i=0; i<cols.length; ++i) {
                //         var w_k = w_j.slice(i>0 ? cols[i-1].index : 0, cols[i].index);
                //         var w_r = w_k.reduce(function(sum, value) {
                //             return sum + value;
                //         }, 0);
                //         x = W/2 - w_r/2;
                //         w_k.forEach(function(value) {
                //             L.push({x: x, y: y, w: value, h: h});
                //             x += value;
                //         });
                //         y += h;
                //     }

                //     if (A > A_best) {
                //         A_best = A;
                //         L_best = L;
                //     }
                // }

                //console.log('best area=' + A_best + ' layout=' + JSON.stringify(L_best));

                return L_best;
            } else if (layoutMethod == 'landscape') {
                if (has_maxvideo) {
                    // if max video property is enabled, then determine the best size for the
                    // full size video and the remaining space. Depending on the available space aspect ratio,
                    // the remaining space is either on the right or on the top. Note that a minimum
                    // width of 240px or minimum height of 135 px is assumed, for right or top, respectively.

                    var maxvideo_type = input.filter(function (item) {
                        return item == 'L' || item == 'P';
                    })[0];

                    // keep the calculation similar to flexible method for maxvideo.
                    if (_layoutResizeData) {
                        is_wide = _layoutResizeData.is_wide;
                        var fraction1 = _layoutResizeData.fraction;
                        if (!is_wide) {
                            w0 = W;
                            h0 = H * (1 - fraction1);
                            H = H - h0;
                        } else {
                            h0 = H;
                            w0 = W * (1 - fraction1);
                            W = W - w0;
                        }
                    } else if (maxvideo_type == 'P') {
                        // maxvideo is portrait
                        if (H > W * ratio1) {
                            is_wide = false;
                            w0 = W;
                            h0 = Math.min(W * ratio1, Math.min(Math.max(H * 0.7, H - 135), H * 0.9));
                            H = H - h0;
                        } else {
                            is_wide = true;
                            h0 = H;
                            w0 = Math.min(H / ratio1, Math.min(Math.max(W * 0.7, W - 240), W * 0.9));
                            if (w0 < W / 2) {
                                // if spotlight width is too small, change ratio
                                w0 = Math.min(W / 2, H * ratio2);
                            }
                            W = W - w0;
                        }
                    } else {
                        // maxvideo is landscape
                        if (W > H * ratio1) {
                            is_wide = true;
                            w0 = Math.min(H * ratio1, Math.min(Math.max(W * 0.7, W - 240), W * 0.9));
                            h0 = H;
                            W = W - w0;
                        } else {
                            is_wide = false;
                            h0 = Math.min(W / ratio1, Math.min(Math.max(H * 0.7, H - 135), H * 0.9));
                            w0 = W;
                            if (h0 < H / 2) {
                                // if spotlight height is too small, change ratio
                                h0 = Math.min(H / 2, W / ratio2);
                            }
                            H = H - h0;
                        }
                    }

                    p = findBestArea(W, H, N - 1, ratio1, ratio2);

                    if (!is_wide) {
                        y0 = p.r * p.h;
                    }

                    //     // TODO: keep the older code for reference.
                    //     if (W > H*ratio1) {
                    //         is_wide = true;
                    //         w0 = Math.min(H*ratio1, W - 240);
                    //         h0 = H;
                    //         p = findBestArea(W - w0, H, N-1, ratio1, ratio2);
                    //     } else {
                    //         is_wide = false;
                    //         h0 = Math.min(W/ratio1, H - 135);
                    //         w0 = W;
                    //         p = findBestArea(W, H - h0, N-1, ratio1, ratio2);
                    //         y0 = Math.round(p.r * p.h);
                    //     }

                    _isWideSpotlight = is_wide;

                    w = p.w;
                    h = p.h;
                    c = p.c;
                    r = p.r;

                    // set the dimension of the other videos other than the full size one, in the
                    // remaining space, so as to minimize the empty space in the remaining space.
                    w = Math.floor(w);
                    h = Math.floor(h);
                    w0 = Math.floor(w0);
                    h0 = Math.floor(h0);
                    l = c - c * r + N - 1;

                    var found = 0;
                    return input.map(function (item, index) {
                        if (item == 'L' || item == 'P') {
                            found = 1;
                            // TODO: position left, top to center for max-video.
                            // then set the dimension of the full size video.
                            return { x: x0, y: y0, w: w0, h: h0 };
                        } else {
                            var index1 = index - found;
                            if (is_wide) {
                                y = Math.floor(index1 / c) * h + H / 2 - (r * h) / 2;
                                x = (index1 % c) * w + w0;
                            } else {
                                y = Math.floor(index1 / c) * h;
                                x = (index1 % c) * w + W / 2 - ((index1 < c * (r - 1) ? c : l) * w) / 2;
                            }
                            return { x: x, y: y, w: w, h: h };
                        }
                    });
                } else {
                    // find the best layout that minimizes the empty space in the available space
                    // when all video elements are equal sized.
                    _isWideSpotlight = false;
                    p = findBestArea(W, H, N, ratio1, ratio2);
                    w = p.w;
                    h = p.h;
                    c = p.c;
                    r = p.r;
                    l = c - c * r + N;
                    // w = Math.floor(w); // TODO: commenting, does this break anything?
                    // h = Math.floor(h);
                    return input.map(function (item, index) {
                        y = Math.floor(index / c) * h + H / 2 - (r * h) / 2;
                        x = (index % c) * w + W / 2 - ((index < c * (r - 1) ? c : l) * w) / 2;
                        return { x: x, y: y, w: w, h: h };
                    });
                }
            }
        }

        // The algorithm to find the best layout that minimizes the empty space in the available space,
        // when all the video elements are equal sized.
        // The available space is WxH. There are count number of video elements.
        // The algorithm assumes a video element with aspect ratio between 16:9 and 1:1.
        // It returns the width and height of each video element.
        function findBestArea(W, H, count, ratio1, ratio2) {
            var best_area = 0;
            var best = { w: 0, h: 0, c: 1, r: 1 };

            // iterate through all the grid layouts.
            for (var r = 1; r <= count; ++r) {
                // determine whether the the grid layout will fit the available space
                // horizontally or vertically, so that there is no padding left/right or
                // up/down, respectively.
                var c = Math.ceil(count / r);
                var w = 0,
                    h = 0;
                var w1 = W / c,
                    h1 = H / r;
                if (w1 / h1 < ratio2) {
                    w = W / c;
                    h = w / ratio2;
                } else if (w1 / h1 > ratio1) {
                    h = H / r;
                    w = h * ratio1;
                } else {
                    w = w1;
                    h = h1;
                }
                // determine the total area of all the video elements.
                // if this is the most occupied layout, then mark is as best layout.
                var area = w * h * count;
                if (area > best_area) {
                    best_area = area;
                    best = { w: w, h: h, c: c, r: r };
                }
                //logService.log("" + Math.floor(w) + "x" + Math.floor(h) + "=" + Math.floor(area) + " " + Math.floor(best_area));
            }
            return best;
        }
    }
]);
